import { render, staticRenderFns } from "./Expander.vue?vue&type=template&id=0b3f1450&scoped=true"
import script from "./Expander.vue?vue&type=script&lang=js"
export * from "./Expander.vue?vue&type=script&lang=js"
import style0 from "./Expander.vue?vue&type=style&index=0&id=0b3f1450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f1450",
  null
  
)

export default component.exports